import React from 'react';
import OfflineDriveCompanies from 'src/components/driveAdmin/offlineDriveCompaniesList/OfflineDriveCompanies';

const OfflineDriveCompaniesPage = () => {
	return (
		<div>
			<OfflineDriveCompanies />
		</div>
	);
};

export default OfflineDriveCompaniesPage;
